import { useTranslation } from "react-i18next";

import type { ConditionBadgeParts } from "@/features/segments/types";
import { cn } from "@/lib/utils/cn";

type ConditionTextProps = {
  parts: ConditionBadgeParts;
  id?: string;
};

export function ConditionText({ parts, id }: ConditionTextProps) {
  const { t } = useTranslation();

  return (
    <>
      {parts.markExcluded && (
        <span className="sr-only">{t("admin.segments.builder.excluded")}</span>
      )}
      <span
        id={id}
        className={cn(
          "min-w-0 [overflow-wrap:anywhere]",
          parts.markExcluded && "text-muted-foreground line-through",
        )}
      >
        <span className="font-semibold">{parts.field}</span>
        {parts.operator && (
          <span className="text-muted-foreground"> {parts.operator}</span>
        )}
        {parts.value?.length ? (
          <span className="font-semibold">
            {" "}
            {Array.isArray(parts.value) ? parts.value.join(", ") : parts.value}
          </span>
        ) : null}
      </span>
    </>
  );
}
